import { OptionItem } from '@/types/interfaces'

export const initUser = {
  name: '',
  avatar: '',
  companyName: '',
  phone: '',
  email: '',
  pfUserId: '',
  area: [] as OptionItem[],
  address: '' as string,
}

export type PfUser = typeof initUser
